import { render, staticRenderFns } from "./AudienceHeader.vue?vue&type=template&id=0bdba240&"
import script from "./AudienceHeader.vue?vue&type=script&lang=js&"
export * from "./AudienceHeader.vue?vue&type=script&lang=js&"
import style0 from "./AudienceHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports